<template>
  <v-container fluid>
    <NavDrawer></NavDrawer>
    <AppBar></AppBar>
    <router-view name="default"></router-view>
  </v-container>
</template>

<script>
import AppBar from "@/components/AppBar";
import NavDrawer from "@/components/NavDrawer";

export default {
  name: "Default",
  components: {
    AppBar,
    NavDrawer,
  },
};
</script>